/* ATN Membership - Section 07: Membership Plans mobile slider */
/* Arrows-only horizontal scroller for the mobile slider. Native touch swipe is
   kept intact (no drag handlers) so plan buttons stay clickable. On desktop the
   grid is a static grid and the arrows are hidden via CSS; the JS still runs but
   simply has nothing to scroll. Re-inits on Shopify section load. */
(function () {
  function AtnMemPlans(root) {
    if (!root || root.dataset.plansInit === '1') return;
    root.dataset.plansInit = '1';

    var viewport = root.querySelector('[data-plans-viewport]');
    var prev = root.querySelector('[data-plans-prev]');
    var next = root.querySelector('[data-plans-next]');
    if (!viewport) return;

    function gap() {
      var g = parseInt(getComputedStyle(viewport).columnGap, 10);
      if (isNaN(g)) g = parseInt(getComputedStyle(viewport).gap, 10);
      return isNaN(g) ? 0 : g;
    }

    function step() {
      var card = viewport.querySelector(':scope > *');
      if (!card) return Math.round(viewport.clientWidth * 0.8);
      return Math.round(card.getBoundingClientRect().width + gap());
    }

    function update() {
      var max = viewport.scrollWidth - viewport.clientWidth - 1;
      var x = viewport.scrollLeft;
      if (prev) prev.toggleAttribute('disabled', x <= 0);
      if (next) next.toggleAttribute('disabled', x >= max);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        viewport.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        viewport.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-atn-mem-plans]').forEach(AtnMemPlans);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-atn-mem-plans]');
    if (el) AtnMemPlans(el);
  });
})();